import { LinearProgress, Grid, WithStyles, withStyles } from '@material-ui/core'
import { FC, Fragment } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { addMissingClientInfo, addMissingClientInfoToOverview } from '../../../actions/apartments'
import { UserAttributes } from '../../../services/auth/types'
import { apartmentStyles } from '../../../styles'
import { Apartment } from '../../../types/apartments'
import { StateInterface } from '../../../types/states'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import ApartmentClientInformationForm from '../../Apartment/Forms/ApartmentClientInformationForm'
import { getClientInitialValues } from '../../Apartment/Forms/values/apartmentInitialValues'
import Dialog from '../../Dialog'

type PropsFromState = WithTranslation & WithStyles & WithTranslation

interface DispatchProps {
  dispatchAddMissingClientInfo: (args: any) => void
  dispatchAddMissingClientInfoToOverview: (args: any) => void
}

interface OwnProps {
  areUsersLoading: boolean
  userAttributes: UserAttributes | undefined
  incompleteApartmentData: Apartment | undefined
}

type AddMissingClientInfoDialogProps = OwnProps & DispatchProps & PropsFromState

const AddMissingClientInfoDialog: FC<AddMissingClientInfoDialogProps> = ({
  areUsersLoading,
  userAttributes,
  incompleteApartmentData,
  classes,
  dispatchAddMissingClientInfo,
  dispatchAddMissingClientInfoToOverview,
  t
}) => (
  <Dialog
    dialogId={'AddMissingClientInfo'}
    noOpenDialogButton
    onlyConfirmCloses
    maxWidth='md'
    defaultsToVisible={true}
    fullScreenDialogMobile={true}
    Content={
      <Fragment>
        {areUsersLoading && <LinearProgress />}
        {!areUsersLoading && (
          <Grid container direction='row' justify='space-evenly'>
            <Grid
              item
              className={classes.form}
              xs={12}
              style={{ margin: '10px 15px' }}
            >
              <ApartmentClientInformationForm
                initialValues={getClientInitialValues(undefined, {
                  name: userAttributes?.name || '',
                  phoneNumber: userAttributes?.phone_number || ''
                })}
                updateApartmentClientInformation={dispatchAddMissingClientInfo}
                updateApartmentClientInformationToOverview={dispatchAddMissingClientInfoToOverview}
                isDisabled={false}
                customSubmitLabel='general.confirm'
                classes={classes}
                apartment={incompleteApartmentData}
              />
            </Grid>
          </Grid>
        )}
      </Fragment>
    }
  />
)

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  dispatchAddMissingClientInfo: bindSubmitActionToPromise(
    dispatch,
    addMissingClientInfo
  ),
  dispatchAddMissingClientInfoToOverview: bindSubmitActionToPromise(
    dispatch,
    addMissingClientInfoToOverview
  )
})

export default connect<PropsFromState, DispatchProps, OwnProps, StateInterface>(
  null,
  mapDispatchToProps
)(withStyles(apartmentStyles)(withTranslation()(AddMissingClientInfoDialog)))
